module.exports = __webpack_public_path__ + "img/lamp-street.29003744.svg";